import { lazy, Suspense } from 'react';
import './App.scss';
import './styles/pageBlock.scss';
import LoginPage from './LoginPage/LoginPage';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Component } from 'react';
import FrontendUserLayout from './SecuredArea/FrontendUserLayout';

const LeadsList = lazy(() => import('./SecuredArea/Pages/LeadList'));

const Dashboard = lazy(() => import('./SecuredArea/Pages/Dashboard'));

const ProposalContractList = lazy(() => import('./SecuredArea/Pages/ProposalContractList'));
const LeadBlock = lazy(() => import('./SecuredArea/Pages/LeadBlock'));

const FinancialDocumentsList = lazy(() => import('./SecuredArea/Pages/FinancialDocumentsList'));

const SettlementsList = lazy(() => import('./SecuredArea/Pages/SettlementsList'));

const LoanUpdatesList = lazy(() => import('./SecuredArea/Pages/LoanUpdatesList'));

const PasswordSettings = lazy(() => import('./SecuredArea/Pages/PasswordSettings'));

const ContactDataSettings = lazy(() => import('./SecuredArea/Pages/ContactDataSettings'));

const Ads = lazy(() => import('./SecuredArea/Pages/Ads'));

const ContractConfirmation = lazy(() => import('./Contract/ContractConfirmation'));

const ContractConfirmationSummary = lazy(() => import('./Contract/ContractConfirmationSummary'));

const AutomaticBrokerContactPage = lazy(() => import('./AutomaticBrokerContractForm/AutomaticBrokerContactPage'));
const AutomaticBrokerContractThankYouPage = lazy(() => import('./AutomaticBrokerContractForm/AutomaticBrokerContactFormThankYouPage'));

import ErrorPage from './components/Utils/ErrorPage';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import img404 from './icons/404.svg';
import img403 from './icons/403.svg';
import TagManager from 'react-gtm-module';
import { isAppScripts } from './constants/isAppScripts';
import GainedFinancialDocumentsList from './SecuredArea/Pages/GainedFinancialDocumentsList';
import Integrations from './SecuredArea/Pages/Integrations';
import Integration from './SecuredArea/Pages/Integration';
import IntegrationDetails from './SecuredArea/Pages/IntegrationDetails';
import IntegrationPermissionsTesting from './SecuredArea/Pages/IntegrationPermissionsTesting';
import IntegrationPermissionsProduction from './SecuredArea/Pages/IntegrationPermissionsProduction';
import Plugin from './SecuredArea/Pages/Plugins';
import MarketingResources from './SecuredArea/Pages/MarketingResources';

const tagManagerArgs = {
  gtmId: 'GTM-5NJ5TV4',
};

class App extends Component {
  componentDidMount() {
    const script = document.createElement('script');

    if (isAppScripts) {
      script.src = 'https://eu.fw-cdn.com/10094222/64372.js';
      script.setAttribute('chat', 'false');

      document.head.appendChild(script);
      TagManager.initialize(tagManagerArgs);
    }
  }

  render() {
    return (
        <Router>
          <Switch>
            <Route
              exact
              path='/'
              render={(props) => (
                <FrontendUserLayout>
                  <Suspense>
                    {' '}
                    <Dashboard {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/invoice-loan-list'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <FinancialDocumentsList {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/invoice-loan-gained-list'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <GainedFinancialDocumentsList {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/loan-update-list'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <LoanUpdatesList {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/proposal-contract-list'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <ProposalContractList {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/settlements'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <SettlementsList {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/integrations'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <Integrations {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/integrations/:product/plugins'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <Integration {...props}>
                      <Plugin {...props} />
                    </Integration>
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              path='/integrations/:product/details'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <Integration {...props}>
                      <IntegrationDetails {...props} />
                    </Integration>
                  </Suspense>
                </FrontendUserLayout>
              )}
            />

            <Route
              path='/integrations/:product/permissions/testing'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <Integration {...props}>
                      <IntegrationPermissionsTesting {...props} />
                    </Integration>
                  </Suspense>
                </FrontendUserLayout>
              )}
            />

            <Route
              path='/integrations/:product/permissions/production'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <Integration {...props}>
                      <IntegrationPermissionsProduction {...props} />
                    </Integration>
                  </Suspense>
                </FrontendUserLayout>
              )}
            />

            <Route
              exact
              path='/integration-resources'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <Ads {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/marketing-resources'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <MarketingResources {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/settings/password'
              render={(props) => (
                <FrontendUserLayout>
                  <Suspense>
                    <PasswordSettings {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/settings/contact'
              render={(props) => (
                <FrontendUserLayout>
                  <Suspense>
                    <ContactDataSettings {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/lead-list'
              render={(props) => (
                <FrontendUserLayout isWide={true}>
                  <Suspense>
                    <LeadsList {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/lead-block'
              render={(props) => (
                <FrontendUserLayout>
                  <Suspense>
                    <LeadBlock {...props} />
                  </Suspense>
                </FrontendUserLayout>
              )}
            />
            <Route
              exact
              path='/wspolpraca-dla-brokerow'
              render={() => (
                <Suspense>
                  <AutomaticBrokerContactPage />
                </Suspense>
              )}
            />
            <Route
              exact
              path='/dziekujemy'
              render={() => (
                <Suspense>
                  <AutomaticBrokerContractThankYouPage />
                </Suspense>
              )}
            />
            <Route
              path='/contract-confirmation/'
              render={() => (
                <Suspense>
                  <ContractConfirmation />
                </Suspense>
              )}
            />
            <Route
              path='/contract-confirmation-summary/'
              render={() => (
                <Suspense>
                  <ContractConfirmationSummary />
                </Suspense>
              )}
            />
            <Route
              exact
              path='/login'
              render={(props) => (
                <Suspense>
                  <LoginPage bannersUrl='https://pragmago.pl/wp-json/pragma/v1/banners/splogin' {...props} />
                </Suspense>
              )}
            />
            <Route
              path='/login_switch'
              render={(props) => (
                <Suspense>
                  <LoginPage bannersUrl='https://pragmago.pl/wp-json/pragma/v1/banners/splogin' {...props} />
                </Suspense>
              )}
            />
            <Route
              path='/resetting'
              render={(props) => (
                <Suspense>
                  <LoginPage bannersUrl='https://pragmago.pl/wp-json/pragma/v1/banners/splogin' {...props} />
                </Suspense>
              )}
            />
            <Route
              path='/setting'
              render={(props) => (
                <Suspense>
                  <LoginPage bannersUrl='https://pragmago.pl/wp-json/pragma/v1/banners/splogin' {...props} />
                </Suspense>
              )}
            />
            <Route
              exact
              path='/403'
              render={() => (
                <Suspense>
                  <ErrorPage img={img403} code={403} text={this.props.intl.formatMessage({ id: 'Access denied' })} />
                </Suspense>
              )}
            />
            <Route
              path=''
              render={() => (
                <Suspense>
                  <ErrorPage img={img404} code={404} text={this.props.intl.formatMessage({ id: 'Page not found' })} />
                </Suspense>
              )}
            />
          </Switch>
        </Router>
    );
  }
}

const enhance = compose(
  injectIntl,
  connect((state) => state)
);

export default enhance(App);
